// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1hEg9","content":"styles_content__2XZqG","selectAll":"styles_selectAll__2Lp_p"};